import useBillingStripePaymentMake from 'modules/queries/billing/stripe/payment/useMake';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';

/**
 * Confirms a payment on a newly entered Stripe card. The card was authorized on
 * the way here, while the elements that collected it were still mounted, so all
 * that is left is capturing what it authorized.
 */
const ConfirmNewStripePayment = () => {
	const {
		accountBalanceDisplay,
		authorizedAmount,
		formValues,
		paymentIntentId,
		onSubmitSuccess,
		onSubmitError,
	} = useDialogMakePaymentContext();
	const { mutate: makeStripePayment, isLoading: isMakingPayment } =
		useBillingStripePaymentMake();

	const { amount } = formValues;

	const handleSubmit = () =>
		makeStripePayment(
			// what the card was authorized for, which a capture may not exceed
			{ amount: authorizedAmount, payment_intent_id: paymentIntentId },
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);

	return (
		<ConfirmPaymentContent
			accountBalance={Number(accountBalanceDisplay)}
			amount={Number(amount)}
			isSubmitting={isMakingPayment}
			onSubmit={handleSubmit}
			paymentMethod="credit_card"
			label="Card"
		/>
	);
};

export default ConfirmNewStripePayment;
